export default __webpack_public_path__ + "static/media/Snd_TryO.3c7a405f.mp3";